export default {
    cannotRemoveOwnerLicense: "The owner's license cannot be removed.",
    changeToFreeLicense: 'Change to Free',
    changeToFullLicense: 'Change to Full',
    currentLicenseLimit: 'Current License Limit',
    distributeLicenses: 'Distribute Licenses',
    example: 'This is an example',
    licenseTypeFree: 'Free (read-only)',
    licenseTypeFull: 'Full',
    memberName: 'Name',
    unlimited: 'Unlimited',
    usedLicenses: 'Used Licenses',
    userLicense: 'User License',
};
